import * as React from 'react'
import BaseIcon from 'react-icon-base'
import { IIconProps } from './interface'
import { EColors } from 'app/constants/colors'

const FireEmoji = (props: IIconProps) => (
  <BaseIcon width="19" height="27" viewBox="0 0 19 27" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        d="M10.72-.027c-.554 2.03-.827 4.774 1.33 7.349 2.156 2.574 6.322 6.193 6.556 10.32.234 4.129-1.351 7.025-6.557 8.662l-.215.048c1.344-1.393.288-4.472-2.418-7.847-2.627 2.149-4.352 6.186-2.502 7.867a9.798 9.798 0 0 1-.39-.068l-.058-.02-.099-.037c-.909-.343-5.481-2.29-6.038-6.9-.619-5.121 3.347-4.636 1.455-11.526 1.656.237 3.427 1.472 5.312 3.706-2.609-6.182-1.4-10.033 3.625-11.554z"
        fill={EColors.MEDIUM_GREY}
        fillRule="evenodd"
      />
    </g>
  </BaseIcon>
)

export default FireEmoji
